<template>
  <div id="IntelligentPrediction">
    <p class="view-title">智能应用</p>
    <div class="organize">
      <organize @setOrId="setOrId(arguments)" recoveryName='' @setTree="setTree"></organize>
    </div>
    <div class="list-box" style="top: 77px;">
      <header class="tabs-box clearfix">
        <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>模型管理</span></div>
        <div :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>训练任务</span></div>
      </header>
      <div class="bg t-0">
        <div class="list-top clearfix">
          <el-button type="primary" class="add-btn" @click="addModel" id="addUserBtn" v-show="state==0"
            :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook">新建模型</el-button>
          
          <!-- <div class="search-btn">
                  <el-button type="primary" class="add-btn" @click="search" id="searchBtn">搜索</el-button>
              </div>
              <div class="search">
                  <el-input
                      placeholder="请输入账号或姓名"
                      v-model="searchVal" class="search-input" id="searchUserVal" @keyup.enter.native="search">
                      <i slot="suffix" class="el-input__icon el-icon-search"></i>
                  </el-input>
              </div> -->
        </div>
        <div class="company-list clearfix" v-show="state==0">
          <ul class="list-title">
            <li style="margin-left: 2%;">模型名称</li>
            <li class="w-18">所属企业</li>
            <li class="w-90 min-60">训练状态</li>
            <li class="w-18">训练开始时间</li>
            <li class="w-18">训练完成时间</li>
            <li class="w-90 min-44">训练时间</li>
            <li class="w-90 min-60">应用状态</li>
            <li class="w-90 min-60">应用时间</li>
            <li class="w-90 min-44">平均误差</li>
            <li class="w-26 min-140">操作</li>
          </ul>
          <div class="scroll">
            <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
              <li style="margin-left: 2%;" :title="item.name">{{item.name}}</li>
              <li class="w-18" :title="item.groupName">{{item.groupName}}</li>
              <li class="w-90 min-60" :title="statusTxt(item.trainStatus)" :class="{'color-red':item.trainStatus==4,'color-green':item.trainStatus==3,'color-green2':item.trainStatus==2}">{{statusTxt(item.trainStatus)}}</li>
              <li class="w-18" :title="changeTime(item.trainStart)">{{changeTime(item.trainStart)}}</li>
              <li class="w-18" :title="changeTime(item.trainEnd)">{{changeTime(item.trainEnd)}}</li>
              <li class="w-90 min-44">{{getTime(item.trainTime)}}</li>
              <li class="w-90 min-60" :class="{'color-green':item.applyStatus}">{{item.applyStatus?'启用':'停用'}}</li>
              <li class="w-90 min-60">{{getTime(item.applyTime)}}</li>
              <li class="w-90 min-44">{{item.loss?item.loss:'-'}}</li>
              <li class="w-26 min-140 operate">
                <span @click="viewModel(item)" :id="`view${i}`">查看</span>
                <span :class="{'disabled':!functionSetList.includes('aiEdit')||$store.state.isLook||item.trainStatus==1||item.trainStatus==2}"
                  @click="operate(item,'train',i)" :id="`train${i}`">训练</span>
                <span :class="{'disabled':!functionSetList.includes('aiEdit')||$store.state.isLook||item.trainStatus!=3}"
                  @click="operate(item,'enable',i)" :id="`enable${i}`" v-show="item.applyStatus==0">启用</span>
                <span :class="{'disabled':!functionSetList.includes('aiEdit')||$store.state.isLook||item.trainStatus!=3}"
                  @click="operate(item,'disable',i)" :id="`disable${i}`" v-show="item.applyStatus==1">停用</span>
                <span :class="{'disabled':!functionSetList.includes('aiEdit')||$store.state.isLook}"
                  @click="operate(item,'delete',i)" :id="`delete${i}`">删除</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="company-list clearfix" v-show="state==1">
          <ul class="list-title">
            <li style="margin-left: 3%;">模型名称</li>
            <li class="w-18">所属企业</li>
            <li class="w-90 min-44">训练状态</li>
            <li class="w-18">完成时间</li>
            <li class="w-90">优先级(0-100)</li>
          </ul>
          <div class="scroll">
            <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
              <li style="margin-left: 3%;" :title="item.name">{{item.name}}</li>
              <li class="w-18" :title="item.groupName">{{item.groupName}}</li>
              <li class="w-90 min-44" :title="statusTxt(item.trainStatus)" :class="{'color-red':item.trainStatus==4,'color-green':item.trainStatus==3,'color-green2':item.trainStatus==2}">{{statusTxt(item.trainStatus)}}</li>
              <li class="w-18" :title="changeTime(item.trainEnd)">{{changeTime(item.trainEnd)}}</li>
              <li class="w-90">
                <el-input size="small" :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook" v-model="item.trainSort"
                  @change="setTrainSort(item)" @input="item.trainSort=item.trainSort.replace(/[^\d]/g,'')"></el-input>
              </li>
            </ul>
          </div>
        </div>
        <!-- 没有列表数据 -->
        <div class="nullDataBox" v-show="dataList.length==0">
          <img :src="nullData" class="nullData">
          <span>什么东西都没有找到...</span>
        </div>
      </div>
      <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
    </div>
    <div class="popup">
      <!-- 新建模型 -->
      <div class="popup-add" v-show='addShow'>
        <div class="popup-title">
          新建模型<i class="el-icon-circle-close close" @click="close('add')" id="closeEnable"></i>
        </div>
        <div class="popup-lab t-left">
          <div>
            <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix"
              :disabled="!functionSetList.includes('aiEdit')">
              <el-form-item prop="name" label="模型名称：" class="no-title">
                <el-input v-model="ruleForm.name" id="name"></el-input>
              </el-form-item>
              <div class="train-box" style="justify-content: space-between;">
              <el-form-item label="所属企业：" prop="group" autocomplete="off" class="m-t-0 w-50">
                <div class="popup-lab m-t-0" @mouseleave="selectShow=false" v-show="functionSetList.includes('aiEdit')">
                  <div class="or-Superior" @click='showSelect'>
                    <span class="p-a-l-10">{{orSuperior.name}}</span>
                    <i><img :src="down" @click="showSelect"></i>
                    <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                      <div class="dashed">
                        <el-tree :data="orSuperiorData" :indent='0' node-key="id" ref="editTree"
                          :highlight-current="true" :default-expand-all="true" :check-on-click-node="false"
                          @node-click="selectId" :props="defaultProps">
                          <span class="custom-tree-node" slot-scope="{ node, data }">
                            <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area"
                                class="tree-icon"></i>
                            <span>{{ node.label }}<span
                                v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                          </span>
                        </el-tree>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="popup-lab m-t-0" v-show="!functionSetList.includes('aiEdit')">
                  <div class="or-Superior disabled3">
                    <span class="p-a-l-10">{{orSuperior.name}}</span>
                    <i><img :src="down"></i>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="优先级" prop="trainSort" class="w-50 no-title">
                  <el-input v-model="ruleForm.trainSort" placeholder="请输入0~100" @input="ruleForm.trainSort=ruleForm.trainSort.replace(/[^\d]/g,'')"></el-input>
              </el-form-item>
              </div>
              <el-form-item prop="train" label="训练数据：" class="no-title">
                <div class="train-box m-b-0">
                  <el-form-item prop="trainDevice" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.trainDevice" placeholder="请选择" @change="ruleForm.trainProperty='';devChange(ruleForm.trainDevice)">
                      <el-option v-for="item in deviceList" :key="item.code" :label="item.name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="trainProperty" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.trainProperty" placeholder="请选择">
                      <el-option v-for="item in getPropertyList(ruleForm.trainDevice)" v-if="checkShow(ruleForm.trainDevice,item.identifier)" :key="item.identifier" :label="item.name" :value="item.identifier">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label=""  class="flex-form-item no-title">

                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item prop="predict" label="预测数据：" class="no-title">
                <div class="train-box">
                    <el-form-item prop="predictWindow" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                      <el-input v-model="ruleForm.predictWindow" @change="changeWindow" @input="ruleForm.predictWindow=ruleForm.predictWindow.replace(/[^\d]/g,'')">
                        <template slot="append">分</template>
                      </el-input>
                    </el-form-item>
                  <el-form-item prop="predictDevice" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.predictDevice" placeholder="请选择" @change="ruleForm.predictProperty='';devChange(ruleForm.predictDevice)">
                      <el-option v-for="item in deviceList" :key="item.code" :label="item.name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="predictProperty" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.predictProperty" placeholder="请选择">
                      <el-option v-for="item in getPropertyList(ruleForm.predictDevice)" v-if="checkShow(ruleForm.predictDevice,item.identifier)" :key="item.identifier" :label="item.name" :value="item.identifier">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="" class="no-title extend-box">
                <div class="train-box m-b-10" v-for="item,i in ruleForm.extend" :key="i">
                    <el-form-item :prop="'extend.'+i+'.predictWindow'" label="" class="flex-form-item no-title" :rules="rules.checkSubWindow">
                      <el-input v-model="item.predictWindow" @input="item.predictWindow=item.predictWindow.replace(/[^\d]/g,'')">
                        <template slot="append">分</template>
                      </el-input>
                    </el-form-item>
                  <el-form-item :prop="'extend.'+i+'.predictDevice'" label="" class="flex-form-item no-title" :rules="{required: true, message: '请选择设备', trigger: 'change'}">
                    <el-select v-model="item.predictDevice" placeholder="请选择设备" @change="item.predictProperty='';devChange(item.predictDevice)">
                      <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :prop="'extend.'+i+'.predictProperty'" label="" class="flex-form-item no-title" :rules="{required: true, message: '请选择设备属性', trigger: 'change'}">
                    <el-select v-model="item.predictProperty" placeholder="请选择设备属性">
                      <el-option v-for="pro in getPropertyList(item.predictDevice)" v-if="checkShow(item.predictDevice,pro.identifier)" :key="pro.identifier" :label="pro.name" :value="pro.identifier">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <span class="delAttr" @click="ruleForm.extend.splice(i,1)">删除</span>
                </div>
                <div class="clearfix">
                   <p class="add-train" @click="addTrain">+添加预测数据</p>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <p class="btn-box">
            <el-button type="primary" :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook" @click='createModel'
              id="createBtn">确定</el-button>
            <el-button @click="close('add')">取消</el-button>
          </p>
        </div>
      </div>
      <!-- 查看模型 -->
      <div class="popup-add" v-show='viewShow'>
        <div class="popup-title">
          查看模型<i class="el-icon-circle-close close" @click="close('view')" id="closeEnable"></i>
        </div>
        <div class="popup-lab t-left">
          <div>
            <el-form :model='ruleForm' :rules="rules" ref="viewForm" class="clearfix">
              <el-form-item prop="name" label="模型名称：" class="no-title">
                <el-input v-model="ruleForm.name" id="name" readonly></el-input>
              </el-form-item>
              <div class="train-box" style="justify-content: space-between;">
                <el-form-item label="所属企业：" prop="group" autocomplete="off" class="m-t-0 w-50">
                  <div class="popup-lab m-t-0">
                    <div class="or-Superior ">
                      <span class="p-a-l-10">{{nowObj.groupName}}</span>
                      <i><img :src="down"></i>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="优先级" prop="trainSort" class="w-50 no-title">
                    <el-input v-model="ruleForm.trainSort" readonly placeholder="请输入0~100"></el-input>
                </el-form-item>
              </div>
              <el-form-item prop="train" label="训练数据：" class="no-title">
                <div class="train-box m-b-0">
                  <el-form-item prop="trainDevice" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.trainDevice" placeholder="请选择" @change="ruleForm.trainProperty='';devChange(ruleForm.trainDevice)">
                      <el-option v-for="item in deviceList" :key="item.code" :label="item.name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="trainProperty" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.trainProperty" placeholder="请选择">
                      <el-option v-for="item in getPropertyList(ruleForm.trainDevice)" v-if="checkShow(ruleForm.trainDevice,item.identifier)" :key="item.identifier" :label="item.name" :value="item.identifier">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="" class="flex-form-item no-title">
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item prop="predict" label="预测数据：" class="no-title">
                <div class="train-box">
                    <el-form-item prop="predictWindow" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                      <el-input v-model="ruleForm.predictWindow" @change="changeWindow" @input="ruleForm.predictWindow=ruleForm.predictWindow.replace(/[^\d]/g,'')">
                        <template slot="append">分</template>
                      </el-input>
                    </el-form-item>
                  <el-form-item prop="predictDevice" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.predictDevice" placeholder="请选择" @change="ruleForm.predictProperty='';devChange(ruleForm.predictDevice)">
                      <el-option v-for="item in deviceList" :key="item.code" :label="item.name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="predictProperty" label="" class="flex-form-item no-title" :disabeld="orSuperior.type!=3">
                    <el-select v-model="ruleForm.predictProperty" placeholder="请选择">
                      <el-option v-for="item in getPropertyList(ruleForm.predictDevice)" v-if="checkShow(ruleForm.predictDevice,item.identifier)" :key="item.identifier" :label="item.name" :value="item.identifier">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="" class="no-title extend-box">
                <div class="train-box m-b-10" v-for="item,i in ruleForm.extend" :key="i">
                    <el-form-item :prop="'extend.'+i+'.predictWindow'" label="" class="flex-form-item no-title" :rules="rules.checkSubWindow">
                      <el-input v-model="item.predictWindow" @input="item.predictWindow=item.predictWindow.replace(/[^\d]/g,'')">
                        <template slot="append">分</template>
                      </el-input>
                    </el-form-item>
                  <el-form-item :prop="'extend.'+i+'.predictDevice'" label="" class="flex-form-item no-title" :rules="{required: true, message: '请选择设备', trigger: 'change'}">
                    <el-select v-model="item.predictDevice" placeholder="请选择设备" @change="item.predictProperty='';devChange(item.predictDevice)">
                      <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :prop="'extend.'+i+'.predictProperty'" label="" class="flex-form-item no-title" :rules="{required: true, message: '请选择设备属性', trigger: 'change'}">
                    <el-select v-model="item.predictProperty" placeholder="请选择设备属性">
                      <el-option v-for="pro in getPropertyList(item.predictDevice)" v-if="checkShow(item.predictDevice,pro.identifier)" :key="pro.identifier" :label="pro.name" :value="pro.identifier">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <p class="btn-box">
            <el-button type="primary" :disabled="true"
              id="createBtn">确定</el-button>
            <el-button @click="close('view')">取消</el-button>
          </p>
        </div>
      </div>
      <!-- 启用模型 -->
      <div class="popup-enable" v-show='trainShow'>
        <div class="popup-title">
          训练模型<i class="el-icon-circle-close close" @click="close('train')" id="closeTrain"></i>
        </div>
        <div class="popup-lab t-left">
          系统将训练该模型 “ {{nowObj.name}} ”，是否继续
          <p class="btn-box"><el-button type="primary" :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook" @click='train'
              id="yesTrain">确定</el-button> <el-button @click="close('train')">取消</el-button></p>
        </div>
      </div>
      <!-- 启用模型 -->
      <div class="popup-enable" v-show='enableShow'>
        <div class="popup-title">
          启用模型<i class="el-icon-circle-close close" @click="close('enable')" id="closeEnable"></i>
        </div>
        <div class="popup-lab t-left">
          系统将启用该模型 “ {{nowObj.name}} ”，是否继续
          <p class="btn-box"><el-button type="primary" :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook" @click='enable'
              id="yesEnable">确定</el-button> <el-button @click="close('enable')">取消</el-button></p>
        </div>
      </div>
      <!-- 删除模型 -->
      <div class="popup-enable" v-show='deleteShow'>
        <div class="popup-title">
          删除模型<i class="el-icon-circle-close close" @click="close('delete')" id="closeEnable"></i>
        </div>
        <div class="popup-lab t-left">
          系统将删除该模型 “ {{nowObj.name}} ”，是否继续
          <p class="btn-box"><el-button type="primary" :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook" @click='deleteModel'
              id="yesDelete">确定</el-button> <el-button @click="close('delete')">取消</el-button></p>
        </div>
      </div>
      <!-- 停用模型 -->
      <div class="popup-enable" v-show='disableShow'>
        <div class="popup-title">
          停用模型<i class="el-icon-circle-close close" @click="close('disable')" id="closeDisable"></i>
        </div>
        <div class="popup-lab t-left">
          系统将停用该模型 “ {{nowObj.name}} ”，是否继续
          <p class="btn-box"><el-button type="primary" :disabled="!functionSetList.includes('aiEdit')||$store.state.isLook" @click='disable'
              id="yesDisable">确定</el-button> <el-button @click="close('disable')">取消</el-button></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from "@/components/PublicAssembly/pagination"
  import Organize from "@/components/PublicAssembly/organize"
import { JSONStringify } from "../../pages/config/functions"
  export default {
    data() {
      var valiGroup = (rule, value, callback) => {
        if (!this.orSuperior.type) {
          callback(new Error('请选择所属企业'))
        } else if (this.orSuperior.type == 3) {
          callback()
        } else {
          callback(new Error('请选择企业类型'))
        }
      }
      var valiTrain = (rule, value, callback) => {
        callback()
      }
      var valiPredict = (rule, value, callback) => {
        callback()
      }
      var valiPredictWindow = (rule, value, callback) => {
        if(value==0){
          callback(new Error('预测时间不能低于1分钟'))
        }else if(value>1440){
          callback(new Error('预测时间不能超过1440分钟'))
        }else{
          callback()
        }
      }
      var validatorPredictWindow = (rule, value, callback) => {
        console.log(value)
        if(value==0){
          callback(new Error('预测时间不能低于1分钟'))
        }else if(Number(value)>this.ruleForm.predictWindow){
          callback(new Error('预测时间不能超过'+this.ruleForm.predictWindow+'分钟'))
        }else{
          callback()
        }
      }

      var validTrainSort = (rule, value, callback) => {
        if(Number(value)>100||Number(value)<0){
          callback(new Error('请输入0~100的整数'))
        }else{
          callback()
        }
      }
      return {
        Tree: [],
        setOrcode: false,
        orCode: 1,
        orSuperior: {}, //上级组对象
        oldorSuperior: {},
        orSuperiorData: [], //所属组tree结构数据
        functionSetList: [],
        nullData: require('@/assets/image/index/nullData.png'),
        down: require('@/assets/image/organize/down.png'),
        area: require('@/assets/image/company/qyzu.png'),
        branch: require('@/assets/image/company/ptzu.png'),
        location: require('@/assets/image/company/jczu.png'),
        VerifyArr: [],
        state: 0,
        dataList: [],
        ruleForm: {
          name: "",
          trainDevice: "",
          trainProperty: "",
          predictWindow:1,
          predictDevice:"",
          predictProperty:"",
          extend:[],
          trainSort:1
        },
        rules: {
          checkSubWindow:[{
            required: true,
            validator: validatorPredictWindow,
            trigger: 'change'
          }],
          trainSort:[{
              required: true,
              message: '请输入优先级',
              trigger: 'blur'
            },{
            required: true,
            validator: validTrainSort,
            trigger: 'change'
          }],
          name: [{
              required: true,
              message: '请输入模型名称',
              trigger: 'blur'
            },
            {
              max: 32,
              message: '最大支持32个字符',
              trigger: 'blur'
            },
          ],
          group: [{
            required: true,
            validator: valiGroup,
            trigger: 'submit'
          }],
          train: [{
            required: true,
            validator: valiTrain,
            trigger: 'submit'
          }],
          predict: [{
            required: true,
            validator: valiPredict,
            trigger: 'submit'
          }],
          trainDevice: [{
            required: true,
            message: '请选择设备',
            trigger: 'change'
          }],
          trainProperty: [{
            required: true,
            message: '请选择设备属性',
            trigger: 'change'
          }],
          predictWindow: [{
            required: true,
            message: '请输入预测时间',
            trigger: 'change'
          },{
            required: true,
            validator: valiPredictWindow,
            trigger: 'change'
          }],
          predictDevice: [{
            required: true,
            message: '请选择设备',
            trigger: 'change'
          }],
          predictProperty: [{
            required: true,
            message: '请选择设备属性',
            trigger: 'change'
          }],
        },
        totalCount: 1,
        addShow: false,
        enableShow: false,
        disableShow: false,
        deleteShow:false,
        selectShow: false,
        viewShow:false,
        trainShow:false,
        nowIndex: null,
        nowObj: {},
        roleId: null,
        deviceList: [],
        productList: [],
        pageNumber: 1,
        defaultProps: {
          children: 'children',
          label: 'name',
          disabled: (data, node) => {
            if (data.type == 3) {
              return false
            } else {
              return true
            }
          }
        },
      }
    },
    components: {
      Pagination,
      Organize
    },
    computed: { 
      getPropertyList() {
        return (code) => {
          if (code) {
            let dev = this.deviceList.find(item => item.code == code)
            if (!dev) {
              return []
            }
            let pro = this.productList.find(item => item.id == dev.productId)
            if (!pro) {
              return []
            } else {
              let dev = this.deviceList.find(item=>item.code==code)
              
              if(!dev){
                return []
              }
              let properties = pro.properties.filter(item=>dev.propertySet.includes(item.identifier))
              return properties || []
            }
          } else {
            return []
          }
        }
      },
      checkShow(){
        return (code,identifier)=>{
          if(!code||!identifier){
            return false
          }else{
            let dev = this.deviceList.find(item=>item.code==code)
            if(!dev){return false}
            return dev.propertySet.includes(identifier)
          }
        }
      },
      statusTxt() {
        return (status) => {
          if (status == 1) {
            return '待训练'
          } else if (status == 2) {
            return '训练中'
          } else if (status == 3) {
            return '训练完成'
          } else if (status == 4) {
            return '训练失败'
          } else {
            return '未训练'
          }
        }
      },
      getTime() {
        return (seconds) => {
          if (seconds > 0) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const secs = seconds % 60;

            return [hours, minutes, secs]
              .map(num => (num < 10 ? '0' + num : num))
              .filter((num, i) => i > 0 || hours > 0)
              .join(':');
          } else {
            return '-'
          }
        }
      },
    },
    created() {
      this.$store.state.activeIndex = '/IntelligentPrediction'
      this.getTree('a')
      this.pageSize = this.$store.state.userConfig.rowsPerPage;
    },
    methods: {
      changeWindow(){
        for(let i in this.ruleForm.extend){
          this.$refs.addForm.validateField('extend.'+i+'.predictWindow')
        }
      },
      // 新增预测数据
      addTrain(){
        this.$set(this.ruleForm.extend,this.ruleForm.extend.length,{
          predictWindow:1,
          predictDevice:"",
          predictProperty:""
        })
      },
      // 变更设备
      async devChange(code){
        let dev = this.deviceList.find(item=>item.code==code)
        if(!dev){
          return
        }
        let pro = this.productList.find(item=>item.id==dev.productId)
        if(!pro){
          await this.getTsl(code,dev.productId)
        }
      },
      // 获取tsl
      getTsl(code,pid){
        this.get('/ProductFeature/getByDeviceCode?code='+code).then(res=>{
          if(res.success){
            res.result = JSON.parse(res.result)
            let pro ={
              id:pid,
              properties:res.result.properties
            }
            console.log(res,pro)
            this.productList.push(pro)
          }else{
            this.$message({
              message: `获取设备属性失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 展开上级组
      showSelect() {
        var box = this.$refs.selectbox;
        this.selectShow = true;
      },
      // 获取用户点击的上级组节点
      selectId(data) {
        if (this.orSuperior.code == data.code) {
          this.selectShow = false;
          return
        }
        this.orSuperior = data;
        this.ruleForm.groupCode = data.code;
        this.selectShow = false;
        this.$refs.addForm.validateField("group")
        let groupCode = null,
          deviceList = []
        // console.log(data)
        if (data.type == 3) {
          groupCode = data.code
          this.get('/Device/getList', {
            companyId: data.id
          }).then(res => {
            if (res.success) {
              res.result.forEach(item=>{
                item.propertySet = item.propertySet.split(',')
              })
              this.deviceList = res.result
              deviceList = res.result
            } else {
              this.$message({
                message: `获取企业设备列表失败:${res.message}`,
                type: 'warning'
              });
            }
          })
        }
        this.ruleForm.trainDevice=""
        this.ruleForm.trainProperty=""
        this.ruleForm.predictDevice=""
        this.ruleForm.predictProperty=""
        for(let item of this.ruleForm.extend){
          item.predictDevice=""
          item.predictProperty=""
        }
        this.$forceUpdate()
      },
      viewModel(obj){
        this.nowObj = JSON.parse(JSON.stringify(obj));
        this.nowObj.extend=JSON.parse(this.nowObj.extend)
        this.ruleForm=this.nowObj
        // this.initForm()
        this.get('/Company/get?code='+this.nowObj.groupCode).then(res=>{
          if(res.success){
            this.get('/Device/getList', {
              companyId: res.result[0].id
            }).then(res => {
              if (res.success) {
                res.result.forEach(item=>{
                  item.propertySet = item.propertySet.split(',')
                })
                this.deviceList = res.result
                this.devChange(this.ruleForm.trainDevice)
                this.devChange(this.ruleForm.predictDevice)
                for(let item of this.ruleForm.extend){
                  this.devChange(item.predictDevice)
                }
              } else {
                this.$message({
                  message: `获取企业设备列表失败:${res.message}`,
                  type: 'warning'
                });
              }
            })
          } else {
            this.$message({
              message: `获取所属企业失败:${res.message}`,
              type: 'warning'
            });
          }
        })
        this.viewShow=true
        this.$store.state.mask=true
      },
      operate(obj, name, i) {
        if(!this.functionSetList.includes('aiEdit')||this.$store.state.isLook){
          return
        }else if(name=='train'&&(obj.trainStatus==1||obj.trainStatus==2)){
          return
        }else if((name=='enable'||name=='disable')&&obj.trainStatus!=3){
          return
        }
        name += "Show";
        this.nowObj = obj;
        this.nowIndex = i;
        this[name] = true
        this.$store.state.mask = true
      },
      createModel(){
        this.$refs.addForm.validate(valid=>{
          if(valid){
            let obj = this.clone(this.ruleForm)
            obj.predictWindow=Number(obj.predictWindow)
            obj.trainSort=Number(obj.trainSort)
            obj.extend=JSON.stringify(obj.extend)
            this.postNoJson("/AI/create",obj).then(res=>{
              if (res.success) {
                this.$message({
                  message: '新建成功',
                  type: 'success'
                });
                this.getlist();
              } else {
                this.$message({
                  message: `新建失败：${res.message}`,
                  type: 'warning'
                });
              }
              this.$store.state.mask = false;
              this.addShow = false;
            })
          }
        })
      },
      close(name) {
        if(name=='add'||name=='view'){
          this.ruleForm = this.$options.data().ruleForm
          this.$refs.addForm.clearValidate()
          setTimeout(()=>{
            this.$refs.addForm.clearValidate(["train","predict","trainDevice","trainProperty","predictDevice","predictProperty"])
          })
        }
        name += "Show";
        this[name] = false
        this.$store.state.mask = false
      },
      // 删除模型
      deleteModel() {
        let parm = {
          id: this.nowObj.id
        }
        this.get('/AI/remove', parm).then((res) => {
          if (res.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getlist();
          } else {
            this.$message({
              message: `删除失败：${res.message}`,
              type: 'warning'
            });
          }
          this.$store.state.mask = false;
          this.deleteShow = false;
        })
      },
      // 训练模型
      train(){
        let parm = {
          id: this.nowObj.id
        }
        this.post('/AI/train', parm).then((res) => {
          // console.log(res)
          if (res.success) {
            this.$message({
              message: '开始训练',
              type: 'success'
            });
            this.getlist()
          } else {
            this.$message({
              message: `训练失败：${res.message}`,
              type: 'warning'
            });
          }
          this.$store.state.mask = false;
          this.trainShow = false;
        })
      },
      //启用模型
      enable() {
        let parm = {
          id: this.nowObj.id
        }
        this.post('/AI/enable', parm).then((res) => {
          // console.log(res)
          if (res.success) {
            this.$message({
              message: '启用成功',
              type: 'success'
            });
            this.dataList[this.nowIndex].applyStatus = 1;
          } else {
            this.$message({
              message: `启用失败：${res.message}`,
              type: 'warning'
            });
          }
          this.$store.state.mask = false;
          this.enableShow = false;
        })
      },
      //停用模型
      disable() {
        let parm = {
          id: this.nowObj.id
        }
        this.post('/AI/disable', parm).then((res) => {
          // console.log(res)
          if (res.success) {
            this.$message({
              message: '停用成功',
              type: 'success'
            });
            this.dataList[this.nowIndex].applyStatus = 0
          } else {
            this.$message({
              message: `停用失败：${res.message}`,
              type: 'warning'
            });
          }
          this.$store.state.mask = false;
          this.disableShow = false;
        })
      },
      setTrainSort(item) {
        console.log(item.oldTrainSort, item.trainSort)
        if (!item.trainSort) {
          item.trainSort = item.oldTrainSort
        } else if (item.trainSort > 100 || item.trainSort < 0) {
          this.$message({
            type: "warning",
            message: "请输入0-100的数字"
          })
        } else {
          let parm = {
            id: item.id,
            sort: item.trainSort
          }
          this.post("/AI/updateSort", parm).then(res => {
            if (res.success) {
              this.$message({
                message: `修改成功`,
                type: 'success'
              });
              this.getlist()
            } else {
              this.$message({
                message: `获取列表数据失败：${res.message}`,
                type: 'warning'
              });
            }
          })
        }
      },
      // 修改分页size
      setSize(pageObj) {
        this.pageSize = pageObj.size;
        this.getlist();
      },
      // 修改页数
      setNum(number) {
        this.pageNumber = number;
        this.getlist();
      },
      addModel() {
        this.addShow = true
        this.$store.state.mask = true
      },
      headClick(state) {
        this.state = state
        this.pageNumber = 1
        this.getlist()
      },
      setTree() {
        this.getTree()
      },
      getTree(type) {
        this.get('/Group/getOrganizationTree').then((res) => {
          if (res.success) {
            this.Tree = res.result;
            this.setOrcode = true;
            this.orCode = this.Tree[0].code
            this.$store.state.treeData = this.Tree
            this.orSuperior = {}
            this.oldorSuperior = this.clone(this.orSuperior)
            this.functionSetList = this.$store.state.treeData[0].functionSet.split(',')
            this.$store.state.expandedArr = []
            this.expanded(this.$store.state.treeData, 1)
            if (type == 'a') {
              this.roleId = this.$store.state.treeData[0].roleId
              this.getlist();
              this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
            }
            this.orSuperiorData = [] //初始化树
            for (let obj of res.result) {
              if (obj.roleId == this.roleId) { //获取当前角色下树数据
                obj = this.clone(obj)
                this.orSuperiorData.push(obj)
                return
              }
            }
          }
        })
      },
      setOrId(node) {
        // console.log(node)
        this.roleId = node[0].roleId
        this.orSuperiorData = []
        for (let obj of this.$store.state.treeData) {
          if (node[0].roleId == obj.roleId) { //获取当前角色下的树数据
            obj = this.clone(obj)
            this.orSuperiorData.push(obj)
          }
        }
        this.orCode = node[0].code;
        this.functionSetList = node[1]
        this.orSuperior = {};
        this.oldorSuperior = this.clone(this.orSuperior)
        this.setCount = true
        this.pageNumber = 1
        this.getlist()
      },
      // 获取列表
      getlist() {
        let parm = {
          pageNumber: this.pageNumber,
          length: this.pageSize,
          code: this.orCode
        }
        let url = this.state == 0 ? '/AI/query' : '/AI/queryTask'
        this.get(url, parm).then((res) => {
          if (res.success) {
            this.dataList = res.result.data;
            this.dataList.forEach(item => {
              item.oldTrainSort = item.trainSort
            })
            if (this.setCount) {
              this.totalCount = res.result.totalCount;
              this.setCount = false
            }
          } else {
            this.$message({
              message: `获取列表数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .color-green{
    color: #0c3;
  }
  .color-green2{
    color: #91de94;
  }
  .color-red{
    color: red !important;
  }
  .extend-box{
    max-height: 220px;
    overflow: auto;
  }
  #IntelligentPrediction{
    .train-box {
      display: flex;
      width: 100%;
      justify-content: flex-start;
      &>>>.el-input__icon{
        line-height: 34px;
      }
      &.m-b-0>>>.el-form-item{
        margin-bottom: 0 !important;
      }
      .flex-form-item{
        width: 152px !important;
        margin-right: 10px;
      }
      .trainSort-box{
        margin-top: -40px;
      }
      &.m-b-10{
        margin-bottom: 10px;
      }
      .delAttr {
          float: right;
          color: #5087e4;
          cursor: pointer;
      }
    }
  }

  .add-train{
    color: #5087e4;
    cursor: pointer;
    float: left;
  }
  .disabled3 {
    background-color: #F5F7FA !important;
    color: #C0C4CC !important;
    cursor: not-allowed;
  }

  .or-Superior {
    height: 34px;
    line-height: 34px;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    padding: 0 10px;
    position: relative;
    box-sizing: border-box;
    top: 40px;
    margin-bottom: 40px;

    i {
      float: right;
    }

    img {
      width: 22px;
      margin-top: 6px;
    }

    img.tree-icon {
      width: 16px !important;
      position: relative;
      top: 3px;
      left: -2px;
    }

    .select-box {
      width: 100%;
      position: absolute;
      left: -1px;
      top: 32px;
      border: 1px solid #e5e5e5;
      max-height: 315px;
      overflow: auto;
      /* width: 370px; */
      border-radius: 5px;
      z-index: 99;
      background: #fff;
    }

    .p-a-l-10 {
      position: absolute;
      left: 10px;
    }

  }

  .popup>div {
    position: fixed;
    top: 10%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -406px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 30px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px !important;
    margin-top: 22px !important;

    & .m-t-0 {
      margin-top: 0 !important;
    }
  }

  .popup-enable .popup-title {
    margin-bottom: 12px;
  }

  .popup-add {
    max-height: 762px !important;
    top: calc(50% - 380px) !important;
    padding-bottom: 80px !important;
  }

  .popup-enable {
    height: 284px;
    position: relative;
  }

  .btn-box {
    position: absolute;
    text-align: center;
    bottom: 36px;
    width: 100%;
    left: 0;
  }

  .btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .organize {
    position: absolute;
    top: 36px;
    bottom: 0;
  }

  .list-box {
    position: absolute;
    top: 36px;
    left: 328px;
    right: 0;
    bottom: 0;

    .list-top {
      margin: 0px 16px 15px 16px;
      padding-top: 24px;
    }
  }

  .tabs-box {
    float: left;
    height: 40px;
    overflow: hidden;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border: 1px solid #d2d2d2;
    position: absolute;
    top: -43px;

    div {
      float: left;
      padding: 9px 0;
    }

    span {
      float: left;
      display: inline-block;
      width: 110px;
      font-size: 14px;
      line-height: 22px;
      border-left: 1px solid #e2e2e2;
      cursor: pointer;
    }

    .active {
      background: #5087e4;
      color: #fff;

      span {
        border: 0;
      }
    }
  }

  .bg {
    width: 100%;
    margin-top: 42px;
    height: 90%;
  }

  .add-btn {
    float: left;
    line-height: 32px !important;
    padding: 0 15px !important;
  }

  .search {
    float: right;
    width: 388px;
    margin-right: 10px;
  }

  .search-btn {
    float: right;
  }

  .list-title,
  .list-details {
    display: flex;
    justify-content: space-around;
    line-height: 44px;
    font-size: 14px;
    color: #636363;
  }

  .list-title {
    background: #eeeeee;
  }

  .list-title li,
  .list-details li {
    width: 200px;
    margin: 0 5px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list-details {
    border-top: 1px solid #f2f2f2;
  }

  .operate span {
    margin: 0 4px;
    color: #5087e4;
  }

  .w-18 {
    width: 18% !important;
  }

  .w-90 {
    width: 90px !important;
    margin-right: 15px !important;
  }

  .min-140 {
    min-width: 160px;
  }

  .min-44 {
    min-width: 44px;
  }
  .min-60{
    min-width: 60px;
  }
  .scroll {
    overflow: auto;
    width: 97.6%;
    max-height: 88% !important;
    height: 88%;
    margin: 0 16px;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .bg.t-0 {
    margin-top: 0 !important;
  }

  .tabs-box>div:first-child span {
    border: none;
  }

  .company-list {
    overflow: hidden;
    margin-bottom: 32px;
    height: 90%;
  }
</style>
<!-- 修改默认样式 -->
<style>
  #IntelligentPrediction .tree-box .el-tree-node__content {
    padding-left: 14px !important;
  }

  #IntelligentPrediction .tree .el-tree-node {
    width: 263px;
    padding-right: 30px;
    box-sizing: border-box;
  }

  #userList .tree-box.left-17 .el-tree-node__children {
    position: relative;
    left: 17px !important;
  }

  #IntelligentPrediction .popup .el-input__inner {
    line-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }

  #IntelligentPrediction .popup .el-form-item {
    width: 100% !important;
    margin-bottom: 12px !important;
  }
  #IntelligentPrediction .popup .el-form-item.w-50 {
    width: 48% !important;
  }
  #IntelligentPrediction .popup .el-form-item__label {
    padding: 0 !important;
  }

  #IntelligentPrediction .popup .el-form-item__content {
    line-height: 34px !important;
  }

  #IntelligentPrediction .search .el-input__inner {
    line-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }

  #IntelligentPrediction .search .el-icon-search {
    line-height: 34px !important;
  }

  #IntelligentPrediction .p-l-0 .el-tree-node {
    padding-left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/IntelligentPrediction/index.vue